<template>
  <div class="setlong">
    <Head :title="title"></Head>
    <div class="setlong_bottom">
      <van-form @submit="onSubmit">
        <van-field
          style="border-radius: 8px 8px 0px 0px"
          v-model="newPassword"
          type="password"
          placeholder="请输入新密码"
        />
        <van-field
          style="border-radius: 0px 0px 8px 8px"
          v-model="confirmPassword"
          type="password"
          placeholder="请确认新密码"
        />
        <div class="prompt">密码至少6位,包含数字/字母/字符2种</div>
        <van-button class="bto" type="primary" native-type="submit"
          >提交</van-button
        >
      </van-form>
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
export default {
  name: "setlong",
  data() {
    return {
      title: "设置登录密码",
      newPassword: "",
      confirmPassword: "",
    };
  },
  components: {
    Head,
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    onSubmit() {
      if (this.newPassword === "") {
        this.$toast("新密码不能为空");
        return;
      }
      if (this.confirmPassword === "") {
        this.$toast("确认新密码不能为空");
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$toast("两次输入的密码不一致");
        return;
      }
      // 提交表单
      console.log(111);
    },
  },
};
</script>

<style lang="scss" scoped>
.setlong {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .setlong_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    position: relative;
    .my {
      width: 150px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .setlong_bottom {
    width: 94%;
    margin: 0 auto;
    margin-top: 12px;
    border-radius: 8px;
    overflow: hidden;
    .prompt {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
      padding: 0px 0px 0px 15px;
    }
    .bto {
      width: 94%;
      margin: 49px auto;
      height: 44px;
      background: #4a79f1;
      border-radius: 22px;
      border: none;
    }
  }
}
</style>